/* istanbul ignore file */
import React from 'react';

import { useSelector } from '@lumapps/redux/react';

import { isContentTypesAllowed } from '../../ducks/selectors';
import {
    ContentTypesSideNavigation as ContentTypesSideNavigationComponent,
    ContentTypesSideNavigationProps,
} from './ContentTypesSideNavigation';

const ContentTypesSideNavigationWrapper: React.FC<Partial<Omit<ContentTypesSideNavigationProps, 'isAllowed'>>> = (
    props,
) => {
    const isAllowed = useSelector(isContentTypesAllowed);

    return <ContentTypesSideNavigationComponent {...props} isAllowed={isAllowed} />;
};

ContentTypesSideNavigationWrapper.displayName = 'ContentTypesSideNavigation';

export { ContentTypesSideNavigationWrapper as ContentTypesSideNavigation };
